import { useEffect, useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { breakpoints } from 'styles';
import { EmptyIndicator, MoreOptions, Pagination } from 'components/common';
import { AdminGroupAvatar } from 'components/common/admins';
import {
  Box,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import { AdminGroupsHeader, AdminGroupsUpdate, AdminGroupsRemove } from '.';

import type { AdminGroup } from 'shared-types';

export type IAdminGroupsUpdate = { page?: number; search?: string };

const AdminGroups = () => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const [adminGroups, setAdminGroups] = useState<AdminGroup[]>([]);
  const [state, setState] = useState({
    page: 1,
    pages: 1,
    search: ''
  });

  useEffect(() => {
    getAdminGroups({});
  }, []);

  const getAdminGroups = async ({ page, search }: IAdminGroupsUpdate) => {
    try {
      const pageValue = page !== undefined ? page : state.page;
      const searchValue = search !== undefined ? search : state.search;

      const response = await api.get(
        `/admin/admin-groups?page=${pageValue}&search=${searchValue}`
      );
      setAdminGroups(response.data.adminGroups);
      setState({
        page: pageValue,
        pages: response.data.pages,
        search: searchValue
      });
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  return (
    <>
      <Box
        headerContent={<AdminGroupsHeader updateGroups={getAdminGroups} />}
        headerContentWrap={true}
        padding={0}
        title={messages.adminGroups}
      >
        {adminGroups.length ? (
          <BoxTable>
            <BoxTableHeader>
              <BoxTableCell cellBreakpoint={breakpoints.medium}>
                {messages.commonTitle}
              </BoxTableCell>
              <BoxTableCell cellBreakpoint={breakpoints.medium}>
                {messages.usersAdmins}
              </BoxTableCell>
              <BoxTableCell shrink={true}></BoxTableCell>
            </BoxTableHeader>

            {adminGroups.map((adminGroup) => (
              <BoxTableRow key={adminGroup.id}>
                <BoxTableCell cellBreakpoint={breakpoints.medium}>
                  <AdminGroupAvatar adminGroup={adminGroup} titleOnly={true} />
                </BoxTableCell>
                <BoxTableCell cellBreakpoint={breakpoints.medium}>
                  {adminGroup.addedUsers.length}
                </BoxTableCell>
                <BoxTableCell>
                  {adminGroup.isEditable ? (
                    <MoreOptions styleContentButtons={false}>
                      <AdminGroupsUpdate
                        adminGroup={adminGroup}
                        updateGroups={getAdminGroups}
                      />
                      <AdminGroupsRemove
                        adminGroupId={adminGroup.id}
                        updateGroups={getAdminGroups}
                      />
                    </MoreOptions>
                  ) : null}
                </BoxTableCell>
              </BoxTableRow>
            ))}
          </BoxTable>
        ) : (
          <EmptyIndicator icon="users" title={messages.adminGroupsNotFound} />
        )}
      </Box>

      <Pagination
        currentPage={state.page}
        numberOfPages={state.pages}
        onPageChange={getAdminGroups}
      />
    </>
  );
};

export default AdminGroups;
